import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip from "react-bootstrap/esm/Tooltip";

type WorkflowVisualizationContextMenuActionButtonProps = {
    label: string;
    action: (id: string) => void;
    disabled?: boolean;
    tooltip?: string;
    actionId: string;
    idPrefix: string;
    targetId: string;
};

export const WorkflowVisualizationContextMenuActionButton = (props: WorkflowVisualizationContextMenuActionButtonProps) => {
    const {
        label,
        action,
        disabled,
        tooltip,
        actionId,
        idPrefix,
        targetId
    } = props;

    if (disabled) {
        return (
            <OverlayTrigger placement={'right'} overlay={
                (props: any) => {
                    return <Tooltip {...props}>
                        {tooltip}
                    </Tooltip>
                }
            }>
                <button id={`${idPrefix}-${actionId}-button`} disabled={true}>
                    {label}
                </button>
            </OverlayTrigger>
        );
    } else {
        const handleClick = () => action(targetId);

        return (
            <button id={`${idPrefix}-${actionId}-button`} onClick={handleClick}>
                {label}
            </button>
        );
    }
};